import { render } from "./NewLink.vue?vue&type=template&id=4ece58b2"
import script from "./NewLink.vue?vue&type=script&lang=js"
export * from "./NewLink.vue?vue&type=script&lang=js"

import "./NewLink.vue?vue&type=style&index=0&id=4ece58b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__